import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';
import { iconList, isImage, isPdf } from '../constants';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
declare var $: any;

@Component({
	selector: 'file-icon',
	templateUrl: './file-icon.component.html',
	styleUrl: './file-icon.component.scss'
})
export class FileIconComponent implements OnInit {
	File_Storage_URL = environment.File_Storage_URL;
	@Input() file: any = null;
	@Input() isReceipt: boolean = false;
	@Input() isChatFile: boolean = false;
	@Input() candidateName: any = null;
	@Output() amountFetched = new EventEmitter<any>();
	topbar = this.apiService.getNavbar();
	file_name: any = "";
	fileUrl: any = null;
	isImage = false;
	isPdf = false;
	modalId: string = "";
	@ViewChild('modal', { static: true })
	modalTemplate!: TemplateRef<any>;
	private modalRef!: NgbModalRef;
	fetchingAmount = false;

	constructor(private modalService: NgbModal, private sanitizer: DomSanitizer, private toastr: ToastrService, private apiService: ApiService) { }

	ngOnInit(): void {
		this.file_name = this.getFileName();
		this.isPdf = isPdf(this.file_name);
		this.isImage = isImage(this.file_name);
		this.fileUrl = this.File_Storage_URL + this.file;
		let modalId = "filePreviewModal";
		try {
			modalId += this.file_name.split(".")[0];
		} catch (error) { }
		this.modalId = modalId;
	}

	getFileName() {
		try {
			return this.file.split("/").pop() || "";
		} catch (error) {
			return this.file;
		}
	}

	getFileExtension() {
		try {
			let ext = this.file.toLowerCase().split(".").pop();
			let obj = iconList.filter((row: any) => {
				if (row.type === ext) {
					return true;
				} else {
					return false;
				}
			});
			if (obj.length > 0) {
				let icon = obj[0].icon;
				return icon;
			} else {
				return "file";
			}
		} catch (error) {
			return "file";
		}
	}

	removeDomain() {
		try {
			return this.file.replace(/^https?:\/\/[^\/]+\//, "");
		} catch (error) {
			return this.file;
		}
	}

	openPreview() {
		if (this.isChatFile && this.isImage) {
			this.qrNotificationDetails.name = this.candidateName;
		}
		this.modalRef = this.modalService.open(this.modalTemplate, {
			/* windowClass: 'right-modal' */
			size: "xl"
		});
	}

	getSafeUrl(url: any) {
		return this.sanitizer.bypassSecurityTrustResourceUrl(url)
	}

	copyLink() {
		let link = this.File_Storage_URL + this.file;
		navigator.clipboard.writeText(link).then(() => { }).catch(err => { });
		this.toastr.success("Link copied to clipboard", 'Copied', {
			timeOut: 3000,
			tapToDismiss: true,
			closeButton: true
		});
	}

	fetchAmount() {
		this.fetchingAmount = true;
		this.apiService.getAmountFromImage(this.file).subscribe({
			next: (res: any) => {
				this.fetchingAmount = false;
				this.amountFetched.emit(res);
				this.modalRef.close();
			}, error: (error: any) => {
				this.fetchingAmount = false;
				this.toastr.error("Amount not found", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		})
	}

	qrNotificationDetails: any = {
		name: null,
		reason: null,
		amount: null
	};
	qrNotificationLoader = false;
	sendQRNotification() {
		if (!this.qrNotificationDetails.name || !this.qrNotificationDetails.reason || !this.qrNotificationDetails.amount) {
			this.toastr.warning("All fields are mandatory", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		this.qrNotificationLoader = true;
		const payload = { ...this.qrNotificationDetails, url: this.fileUrl };
		this.apiService.qrcodeNotification(payload).subscribe({
			next: (res: any) => {
				this.qrNotificationLoader = false;
				this.modalRef.close();
				this.toastr.success("Notification sent successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}, error: (error: any) => {
				this.qrNotificationLoader = false;
				this.toastr.error("Something went wrong", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		})
	}
}
